
export function SolutionsSection() {
  const solutions = [
    {
      icon: 'ri-brain-line',
      title: 'AI Threat Detection',
      description: 'Intelligent engine analyzing messages, links, and emails using NLP and machine learning trained on UK-specific phishing datasets.',
      features: [
        'Real-time suspicious pattern identification',
        'Malicious URL detection',
        'Social engineering attempt alerts',
        'UK-centric threat intelligence'
      ]
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Employee Training Nudges',
      description: 'Real-time educational nudges when risky behavior is detected, turning everyday use into continuous cyber awareness training.',
      features: [
        'Instant learning moments',
        'Micro-interaction training',
        'Safe habit development',
        'Behavioral risk reduction'
      ]
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Unified SME Dashboard',
      description: 'Simple, easy-to-read dashboard providing business owners with comprehensive cybersecurity insights and actionable intelligence.',
      features: [
        'Detected threat summaries',
        'Employee risk scoring',
        'Security hygiene insights',
        'Compliance reporting'
      ]
    },
    {
      icon: 'ri-cloud-line',
      title: 'Remote Management',
      description: 'Designed for remote deployment across all staff devices without requiring an internal IT department or complex setup.',
      features: [
        'Microsoft 365 integration',
        'Gmail compatibility',
        'WhatsApp Business support',
        'Cross-platform protection'
      ]
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extralight text-white mb-6 leading-tight">
            Comprehensive <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Cybersecurity Solutions</span>
          </h2>
          <p className="text-gray-400 text-xl max-w-3xl mx-auto leading-relaxed">
            Four core pillars of protection designed specifically for UK small and medium enterprises
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group relative bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-blue-500/50 transition-all duration-300 hover:bg-gray-900/70"
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex-shrink-0">
                  <i className={`${solution.icon} text-2xl text-white`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-white mb-4">
                    {solution.title}
                  </h3>
                  <p className="text-gray-400 mb-6 leading-relaxed">
                    {solution.description}
                  </p>
                  
                  <ul className="space-y-3">
                    {solution.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center gap-3 text-gray-300">
                        <i className="ri-check-line text-blue-400 text-lg flex-shrink-0"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-4 bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6">
            <i className="ri-shield-check-line text-3xl text-blue-400"></i>
            <div className="text-left">
              <h4 className="text-xl font-semibold text-white mb-1">Enterprise-Level Protection</h4>
              <p className="text-gray-400">Accessible pricing for businesses of all sizes</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
